/* eslint-disable @typescript-eslint/no-explicit-any */

import { COOKIE_KEYS } from '../lib/constants';
import { getCookie } from './cookieUtils';
import { Data } from '../types';
import { getLocale } from '../lib/helpers';

export const focConfirmationCall = async (eventType: string, datalayer: any, mvpOffers: any): Promise<void> => {
  const baseUrl = datalayer?.['mvp_prequal_endpoint'] as string;
  if (!baseUrl) {
    console.error('There is a problem in making the request');
    return;
  }
  const data: Data = {
    context: {
      localeKey: getLocale(datalayer),
      siteName: 'marriott.com',
      success: true,
      eventType,
      eventInfo: mvpOffers?.eventInfo,
      offerIdentifier: mvpOffers?.offerIdentifier,
    },
    sessionToken: getCookie(COOKIE_KEYS?.sessionID) || '',
    sourceURI: window.location.pathname,
    variation: '0.1',
  };
  try {
    await window.fetch(baseUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
  } catch (err) {
    console.error('Prequal tracking request failed:', err);
  }
};
